<template>
    <div class="task-content">
        <div class="sub-item-box">
            <div class="sub-item-title-box">
                <div class="s-item-title-center">
                    <div class="header-duration-box medium-size">
                        <div class="bg-ellipse-box blue-b">
                            <div class="bg-ellipse-dot dot-left"></div>
                            <div class="bg-ellipse-dot dot-right"></div>
                            <div class="ellipse-text auto-width">
                                <span>任务提交1</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sub-item-content commit-box">
                <!-- 上传文件 -->
                <div class="task-submit_upload">
                    <div class="upload-label">请上传文件</div>

                    <el-upload
                        class="upload-demo"
                        ref="uploadRef"
                        action="#"
                        :on-change="trainFileChange"
                        :auto-upload="false"
                        :show-file-list="false"
                    >
                        <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
                        <div slot="tip" class="el-upload__tip">
                            <i class="el-icon-warning-outline"></i>
                            文件限制100M以内,可上传多个,支持扩展名: rar、zip、doc、docx、xls、xlsx、pdf、jpg、png
                        </div>
                    </el-upload>

                    <div class="upload-list">
                        <div class="upload-file-item" v-for="[key, value] of trainFileMap" :key="key">
                            <img :src="getFileIcon(value.requestData.name)" alt="" />
                            <div class="upload-file-item_name">{{ value.requestData.name }}</div>
                            <i class="upload-file-item_delete el-icon-circle-close" @click="deleteSubmitFile(value)"></i>
                        </div>
                    </div>
                </div>

                <!-- 答题编辑 -->
                <div class="task-submit_editor">
                    <editor :content="content" :height="400" @change="updateContent" />
                    <!-- <editor :content="trainContent" :height="400" @change="updateContent" ref="submitEditorRef" /> -->
                </div>

                <div class="submit-btn-group">
                    <el-button @click="goBack">返回</el-button>
                    <el-button type="primary" @click="submitContent">提交</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Editor from "@/components/utils/Editor.vue";
export default {
    name: "TaskCommit",
    components: {
        Editor,
    },
    props: {
        ids: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            content: "",
            trainFileMap: new Map(), // 学生答题上传文件
        };
    },
    methods: {
        updateContent(val) {
            this.content = val;
        },
        goBack() {
            this.$router.go(-1);
        },
        submitContent() {
            console.log(this.ids);
            console.log(this.content);
            if (/^<p>(&nbsp;|&nbsp;|<br>)+<\/p>$/.test(this.content) || this.content.length === 0) {
                this.$message.warning("任务内容不能为空");
                return;
            }
            let param = {
                content: this.content,
            };
            if (this.ids.sx_id) {
                param.sx_id = this.ids.sx_id;
            } else if (this.ids.project_id) {
                param.project_id = this.ids.project_id;
            }

            const file = [];
            for (let [_, value] of this.trainFileMap) {
                file.push({
                    url: value.requestData.url,
                    name: value.requestData.name,
                    size: value.file ? this.formatFileSize(value.file.size) : value.requestData.size,
                });
            }
            param.file = file;

            this.$shttp.axiosPost(
                this.$api.drill_putDrillData,
                param,
                (res) => {
                    if (res.code === 200) {
                        this.$message({
                            type: "success",
                            message: res.msg,
                            duration: 1000,
                        });
                    }
                },
                (err) => {
                    this.$common.axiosErrorMsg(err);
                },
            );
        },

        // 计算文件大小
        formatFileSize(bytes) {
            if (bytes < 1024) {
                return bytes + " B"; // 如果小于 1 KB，直接返回字节数
            } else if (bytes < 1024 * 1024) {
                return (bytes / 1024).toFixed(2) + " KB"; // 如果小于 1 MB，返回 KB，并保留两位小数
            } else {
                return (bytes / (1024 * 1024)).toFixed(2) + " MB"; // 如果大于等于 1 MB，返回 MB，并保留两位小数
            }
        },

        // 获取文件icon
        getFileIcon(fileName) {
            const iconList = {
                rar: require("../../assets/icons/zip-icon.svg"),
                zip: require("../../assets/icons/zip-icon.svg"),
                doc: require("../../assets/icons/doc-icon.svg"),
                docx: require("../../assets/icons/doc-icon.svg"),
                xls: require("../../assets/icons/xls-icon.svg"),
                xlsx: require("../../assets/icons/xls-icon.svg"),
                pdf: require("../../assets/icons/pdf-icon.svg"),
                jpg: require("../../assets/icons/img-icon.svg"),
                png: require("../../assets/icons/img-icon.svg"),
            };
            const fileExtension = fileName?.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            return iconList[fileExtension] || iconList["jpg"];
        },

        // 手动上传文件
        trainFileChange(file) {
            const fileRaw = file.raw;

            // 判断文件大小
            const maxSize = 100 * 1024 * 1024; // 文件最大100MB
            if (fileRaw.size > maxSize) {
                this.$message.warning("文件大小不能超过100MB");
                return;
            }

            // 判断文件扩展名
            const fileExtension = fileRaw.name.slice(((fileRaw.name.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            const validExtensions = /^(rar|zip|doc|docx|xls|xlsx|pdf|jpg|png)$/;
            // const validExtensions = /^(rar|zip|docx|xlsx|pdf|jpg|png)$/;
            if (validExtensions.test(fileExtension)) {
                const formData = new FormData();
                formData.append("file", fileRaw);

                this.$shttp.axiosPost(this.$api.training_upload, formData, (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.msg);

                        this.trainFileMap.set(res.data.url, {
                            file: fileRaw,
                            requestData: res.data,
                        });
                        this.$forceUpdate(); // 强制更新
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            } else {
                this.$message.warning("文件扩展名仅支持rar、zip、doc、docx、xls、xlsx、pdf、jpg、png");
                // this.$message.warning("文件扩展名仅支持rar、zip、docx、xlsx、pdf、jpg、png");
            }
        },

        // 删除文件
        deleteSubmitFile(fileItem) {
            const key = fileItem.requestData.url;
            this.trainFileMap.delete(key);

            this.$forceUpdate();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./css/project_info";
@import "./css/commit";
</style>
